<template>
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.018 4.668a.72.72 0 0 0-.07-.27.699.699 0 0 0-.151-.227l-2.968-2.968A.7.7 0 0 0 11.332 1a.7.7 0 0 0-.497.203l-1.981 1.98-7.651 7.652A.7.7 0 0 0 1 11.33V14.3a.7.7 0 0 0 .7.7h2.968a.7.7 0 0 0 .532-.204l7.609-7.65L14.797 5.2c.064-.068.153-.189.168-.221a.566.566 0 0 0 .042-.158c.003-.033.014-.12.01-.153ZM4.38 13.599H2.4v-1.98l6.951-6.951 1.981 1.98L4.381 13.6Zm7.938-7.937L10.338 3.68l.994-.987 1.974 1.974-.987.994Z"
      fill="currentColor"
    />
  </svg>
</template>
